import $ from 'jquery';
// add tooltip to disabled button
$('button[disabled][data-disabled-tooltip]').each(function () {
    const tooltipTarget = $(this).parent();
    const tooltip = $(this).data('disabled-tooltip');

    if (!!tooltip) {
        tooltipTarget.tooltip('dispose');
        tooltipTarget.tooltip({
            title: tooltip
        });
    }
});

// add tooltip to button
$('button:not([disabled])[data-tooltip]').each(function () {
    const tooltipTarget = $(this).parent();
    const tooltip = $(this).data('tooltip');

    if (!!tooltip) {
        tooltipTarget.tooltip('dispose');
        tooltipTarget.tooltip({
            title: tooltip
        });
    }
});

export default undefined;
